import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import axiosConfig from '../../../utils/axiosConfig';
import Cookies from 'js-cookie';

const ProtectedRoute = ({ component: Component, ...rest }) => {

    let authUser = Cookies.get('authUser');

    return (
        <Route {...rest} render={
            props => {
                if (authUser) {
                    return <Component {...rest} {...props} />
                } else {
                    return <Redirect to={{
                        pathname: '/login',
                        state: { from: props.location }
                    }} />
                }
            }
        } />
    )
}

export default ProtectedRoute;